//REGISTER USER
import axios from 'axios';
import { ToastsStore } from 'react-toasts';
import {
    GET_ERRORS,
    GET_THEME,
    SET_THEME,
    SIDEBAR_VISIBILITY,
    THEME_LOADING,
} from './types';

/***
 * @const registerUser
 * @param userData : User Registration Data passed form /register
 * @param history : React Redirect Property to be used on registration success
 * @returns {Function} : A redirect to the /login or some errors to be displayed on fail
 */
export const updateThemeAction = (theme) => (dispatch) => {
    dispatch(setThemeLoading());
    return axios
        .post('/api/settings/theme', theme)
        .then(({ data }) => {
            console.log(data);
            ToastsStore.success('Coeus successfully Updated');

            localStorage.setItem('theme', JSON.stringify(data));
            setThemeAction(data);

            dispatch({
                type: SET_THEME,
                payload: data,
            });

            window.location.reload();
        })
        .catch((err) => {
            if (err.response.data) {
                if (err.response.data.flash) {
                    ToastsStore.error(err.response.data.flash);
                }
            }
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const setThemeAction = (palette) => {
    return {
        type: SET_THEME,
        payload: palette,
    };
};

export const getThemeAction = () => (dispatch) => {
    // dispatch(setThemeLoading());

    return axios
        .get('/api/settings/theme')
        .then(({ data }) => {
            localStorage.setItem('theme', JSON.stringify(data));

            setThemeAction(data);
            dispatch({
                type: GET_THEME,
                payload: data,
            });
        })
        .catch((err) => {
            if (err) {
                if (err.response) {
                    dispatch({
                        type: GET_ERRORS,
                        payload: err.response.data,
                    });
                }
            }
        });
};

export const setThemeLoading = () => (dispatch) => {
    dispatch({
        type: THEME_LOADING,
    });
};

export const setSideBarVisibility = (visible) => (dispatch) => {
    dispatch({ type: SIDEBAR_VISIBILITY, payload: visible });
};
